module.exports = __webpack_public_path__ + "img/telephone 7@2x.e962fd90.png";